export const ROUTES = 'ROUTES'
export const APP_LOADING = 'APP_LOADING'
